
window.addEventListener("load", function () {
    // change background khi click quay 10
   
});
